import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function uploadDocx(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/decks", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function loadSample() {
  const { data } = await api.post("/decks/sample");
  return data;
}

export async function getCard(cardId) {
  const { data } = await api.get(`/cards/${cardId}`);
  return data;
}

export function pdfUrl(deckId, flip = "long") {
  const base = encodeURIComponent(window.location.origin);
  return `${API}/decks/${deckId}/pdf?base_url=${base}&flip=${flip}`;
}

export async function getHistory() {
  const { data } = await api.get("/history");
  return data;
}

export async function quizNext(mode = "all") {
  const { data } = await api.get(`/quiz/next?mode=${mode}`);
  return data;
}

export async function quizAnswer(cardId, userAnswer) {
  const { data } = await api.post("/quiz/answer", {
    card_id: cardId,
    user_answer: userAnswer,
  });
  return data;
}

export async function quizDontKnow(cardId) {
  const { data } = await api.post("/quiz/dont-know", { card_id: cardId });
  return data;
}

export async function analyzePdf(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/playground/analyze", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function generatePlaygroundCards(sourceId, topics) {
  const { data } = await api.post("/playground/generate", {
    source_id: sourceId,
    topics,
  });
  return data;
}
